// @flow
import * as React from 'react';
import styled from 'styled-components';
import {isMobile} from './Responsive';

// $FlowFixMe
const images = require.context('../assets/images', true);

export type Props = {
  source: string,
  alt?: string,
};

function getImageLevelMobile(): number {
  if (window.devicePixelRatio >= 2.0) {
    return 2;
  } else {
    return 1;
  }
}

function getImageLevelDesktop(): number {
  return 3;
}

function selectImage(level:number, images:Array<string>): string {
  const idx = level - 1;
  console.assert(idx >= 0 && idx < images.length);
  if (idx >= 0 && idx < images.length) {

  } else {
    console.error("invalid imageset", images, idx);
  }
  return images[idx];
}

export function getImageLevel() : number {
  if (isMobile()) {
    return getImageLevelMobile();
  } else {
    return getImageLevelDesktop();
  }
}

export default function Image(props: Props): React.Element<any> {
  const {source, alt, ...others} = props;
  const images = useImage(source);
  return <img {...others} src={isMobile() ? images.imageMobile : images.imageDesktop} alt={props.alt ?? ''} />;
}

export type PropsBackgroundImage = {
  source: string,
  onClick?: () => void,
};

export const BackgroundImage: React.AbstractComponent<PropsBackgroundImage, any> = React.forwardRef<PropsBackgroundImage, any>(
  (props: PropsBackgroundImage, ref: any) =>  {
  const {source, onClick, ...others} = props;
  const images = useImage(source);
  return <DivBackground {...others} {...images} ref={ref} onClick={onClick} />
});

// export function BackgroundImage(props: PropsBackgroundImage): React.Element<any> {
//   const {source, onClick, ...others} = props;
//   const images = useImage(source);
//   return <DivBackground {...others} {...images} onClick={onClick} />
// }

const DivBackground = styled.div`
  background-image: url(${props => props.theme.layout.mobile ? props.imageMobile : props.imageDesktop });
  background-size: 100% 100%;
`;

export type ImageObject = {
  image: string,
  image2x: string,
  image3x: string,
  imageMobile: string,
  imageDesktop: string,
}

function findImageObject(src: string): ImageObject {
  const extIndex = src?.lastIndexOf('.') ?? -1;
  const filename = src?.substring(0, extIndex) ?? "";
  const ext = src?.substring(extIndex + 1, src.length) ?? "";

  const src1x = images(src).default;
  const src2x = images(`${filename}@2x.${ext}`).default;
  const src3x = images(`${filename}@3x.${ext}`).default;
  const list = [src1x, src2x, src3x];

  return {image: src1x, image2x: src2x, image3x: src3x, imageMobile: selectImage(getImageLevelMobile(), list), imageDesktop: selectImage(getImageLevelDesktop(), list)}
}

export function useImage(src: string): ImageObject {
  const prev = React.useRef(src)
  const [source, setSource] = React.useState(() => findImageObject(prev.current));

  React.useEffect(() => {
    if (src !== prev.current) {
      prev.current = src;
      setSource(findImageObject(prev.current));
    }
  }, [src]);

  return source;
}

export function checkImageExists(src: string): boolean {
  try {
    return images(src) != null;
  }
  catch {
    return false;
  }
}